export default {
  methods: {
    /**
     * storeにエラーメッセージ設定.
     * @param {string} message - メッセージ本文
     */
    setErrorMessage(message) {
      this.$store.dispatch('doSetMessageInfo', { type: 'error', message:message })
    },
    /**
     * storeにエラーメッセージ設定.
     * @param {string} message - メッセージ本文
     */
    addErrorMessage(message) {
      this.$store.dispatch('doAddMessageInfo', { type: 'error', message:message})
    },
    /**
     * storeに警告メッセージ設定.
     * @param {string} message - メッセージ本文
     */
    setWarningMessage(message) {
      this.$store.dispatch('doSetMessageInfo', { type: 'warning', message:message })
    },
    /**
     * storeに成功メッセージ設定.
     * @param {string} message - メッセージ本文
     */
    setSuccessMessage(message) {
      this.$store.dispatch('doSetMessageInfo', { type: 'success', message:message })
    },
    /**
     * storeのメッセージクリア.
     */
    closeMessage() {
      this.$store.dispatch('doSetMessageInfo', { type: '', message:'' })
    },
  },
}
